// Operator-controlled feature flags. The query is keyed without a user id
// so the cached value survives login/logout transitions — the answer is
// the same for everyone on the same deployment.

import { useQuery } from "@tanstack/react-query";

export interface Features {
  images_indexed: boolean;
}

async function fetchFeatures(): Promise<Features> {
  const res = await fetch("/api/v1/features");
  if (!res.ok) return { images_indexed: false };
  return res.json();
}

export function useFeatures() {
  return useQuery<Features>({
    queryKey: ["features"],
    queryFn: fetchFeatures,
    staleTime: 60 * 60 * 1000,
  });
}
